<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <transition v-show="mostrarBarraLateral" name="slide-fade" responsive>
      <b-card class="bCardAgenda bCardAgenda-lateral contenedorTablaSinColor">
          <div class="mb-3" style="display: inline; padding: 5px;" >
            <em style="float: right; height: 10px; transition: transform 1s; color: rgb(96,95,95); cursor:pointer; margin-top: 2px"
                class="equis_svg"
                @click="$emit('activarBarraLateral')"></em>

            <span style="color: #0d86d7; font-weight: 600">Historial de cambios</span>
            <br><br>
            <span style="color: #000000; font-weight: 600" class="ml-1">{{ nombreVale }}</span>
            <br>
            <br>
            <div class="text-center" v-if="loading">
              <b-spinner variant="primary"></b-spinner>
            </div>
            <div class="scrollBarra">
            <template v-for="(historial, index) in listaHistorialConstruida">
                <b-row :key="index" cols="12" class="mr-2">
                  <b-col sm="12" md="12" lg="12">
                    <logo-usuario :usrName="historial.usuario" :fechaModificacion="historial.fechaAlta" class="estiloLogo"/>
                    <p class="formato-letras ml-1 mr-1 text-left" style="font-size: 0.80em;">{{ historial.descripcion }}</p>
<!--                    <p style="font-size: 9px ; text-align:center; color: grey" >}</p>-->
                  </b-col>
                </b-row>
            </template>
            </div>
          </div>
      </b-card>
  </transition>
</div>
</template>

<script>
import LogoUsuario from "@/views/historialPTI/logoUsuario.vue";

export default {
  name: "historialCorto",
  components:{
    LogoUsuario
  },
  props: {
  },
  data(){
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loading: false,
      mostrarBarraLateral: false,
      mostrarBarraLateralHistorial: false,
      loadingCAl: false,

      listaHistorial: [
        {
          nombreModifico: "SOPORTE",
          fechaModifacion: "2023-04-20 15:12:18.228",
          accion: " cambió",
          nombreTx: " el plan a “Plan 20”"
        },
        {
          nombreModifico: "SOPORTE",
          fechaModifacion: "2023-04-20 15:12:18.228",
          accion: " creó",
          nombreTx: " activó el vale"
        },
        {
          nombreModifico: "SOPORTE",
          fechaModifacion: "2023-04-15 15:12:18.228",
          accion: " creó",
          nombreTx: " desactivó el vale"
        },
        {
          nombreModifico: "SOPORTE",
          fechaModifacion: "2023-04-15 15:12:18.228",
          accion: " creó",
          nombreTx: " el vale"
        },
        {
          nombreModifico: "SOPORTE",
          fechaModifacion: "2023-04-15 15:12:18.228",
          accion: " creó",
          nombreTx: " el plan"
        }
      ],
      listaHistorialConstruida: [],
      idRegistro : 0,
      nombreVale: ''
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods:{
    activarBarraLateral(idRegistro, nombreVale) {
      this.nombreVale = nombreVale
      this.idRegistro = idRegistro;
      this.obtenerHistorialVale();
      this.mostrarBarraLateral = !this.mostrarBarraLateral;
      this.mostrarBarraLateralHistorial = this.mostrarBarraLateral;
    },
    obtenerHistorialVale() {
      this.listaHistorial = [];
      this.listaHistorialConstruida = [];
      this.loading = true;
      const params = {
        idModulo: 1,
        idRegistro: this.idRegistro
      }
      this.$http
          .post(this.$api + "vale/obtenerHistorial", params)
          .then((response) => {
            this.listaHistorial = response.data.data;

            this.listaHistorial.forEach(list => {
              if (list.idAccion === 1) {
                this.listaHistorialConstruida.push({usuario: list.usuario,
                  descripcion:
                    list.accion +
                    ' el vale ' +
                  '"' + list.datoNuevo + '"',
                  fechaAlta: list.fechaAlta}
                )
              } else if (list.idAccion === 2) {
                this.listaHistorialConstruida.push({usuario: list.usuario,
                  descripcion:
                    list.accion +
                    ' el campo ' +
                    '"' + list.campo + '"' +
                    ' de ' +
                    '"' + list.datoAnterior + '"' +
                    ' a ' +
                    '"' + list.datoNuevo + '"',
                    fechaAlta: list.fechaAlta}
                )
              } else if (list.idAccion === 3 || list.idAccion === 4) {
                this.listaHistorialConstruida.push({usuario: list.usuario,
                  descripcion:
                    list.accion +
                    ' el vale',
                  fechaAlta: list.fechaAlta}
                )
              } else if (list.idAccion === 5) {
                this.listaHistorialConstruida.push({usuario: list.usuario,
                  descripcion:
                      list.accion +
                      ' el vale de ' +
                      '"' + list.datoAnterior + '"' +
                      ' a ' +
                      '"' + list.datoNuevo + '"',
                  fechaAlta: list.fechaAlta}
                )
              }
            })
          }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>

.bCardAgenda {
  margin: 0.5%;
  padding: 0;
  border-radius: 20px;
}

.bCardAgenda .card-body {
  padding: 0.5rem;
}

.bCardAgenda-lateral {
  height: 100%;
  font-size: 11px;
  font-weight: bolder;
  text-align: left;
}

.estiloLogo{
  padding-bottom: 4px;
  padding-top: 5px;
  padding-left: 6px;
  padding-right: 7px;
  border-radius:20px;
  text-align: left;
  font-size: 1.4vh;
}

.scrollBarra {
  overflow-y: scroll;
  min-height: 30rem;
  max-height: 30rem;
}
</style>